import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <motion.footer 
      className="py-12 px-6 md:px-12 border-t border-neutral-900"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      data-testid="footer"
    >
      <div className="max-w-screen-2xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Company Registration */}
          <div>
            <p className="text-sm text-neutral-400 leading-relaxed">
              Simply Smarter Ltd is a company registered in Scotland
            </p>
            <p className="text-sm text-neutral-500 mt-2">
              Registration number: SC867185
            </p>
          </div>
          
          {/* Address & Contact */}
          <div>
            <p className="text-xs text-neutral-500 uppercase tracking-wider mb-2">
              Registered & Geographical Address
            </p>
            <address className="text-sm text-neutral-400 not-italic leading-relaxed">
              Clyde Offices, 2nd floor<br />
              48 West George Street<br />
              Glasgow, U.K.<br />
              G2 1BP
            </address>
            <a 
              href="mailto:hello@simplysmarter.io"
              className="text-sm text-neutral-400 hover:text-white transition-colors duration-300 mt-4 inline-block"
              data-testid="footer-email"
            >
              Contact us at: hello@simplysmarter.io
            </a>
          </div>
          
          {/* Legal Links */}
          <div>
            <p className="text-xs text-neutral-500 uppercase tracking-wider mb-2">
              Legal
            </p>
            <nav className="flex flex-col gap-2">
              <Link 
                to="/privacy-policy" 
                className="text-sm text-neutral-400 hover:text-white transition-colors duration-300"
                data-testid="privacy-policy-link"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-conditions" 
                className="text-sm text-neutral-400 hover:text-white transition-colors duration-300"
                data-testid="terms-conditions-link"
              >
                Terms & Conditions
              </Link>
            </nav>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-neutral-900">
          <p className="text-xs text-neutral-600" data-testid="copyright-text">
            © {currentYear} Simply Smarter Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
